module.exports = __webpack_public_path__ + "img/icono-exito.f29eb784.svg";